import React, { memo } from 'react'
import { graphql } from 'gatsby'

import Endpoint from '~components/Endpoint'
import ReferenceLayout from '~layouts/ReferenceLayout'

import Head from '~components/Head'

const ReferenceEndpoint = ({
  data, pageContext, location
}) => (
  <ReferenceLayout location={location}>
    <Head title={pageContext.title} />
    <Endpoint endpoint={data.endpoint} />
  </ReferenceLayout>
)

export default memo(ReferenceEndpoint)

export const paramFields = graphql`
  fragment endpointParamFields on Param {
    id
    type
    key
    namespace
    format
    anchor
    enum
    example
    location
    range
    maxLength
    itemType
    showDescription
    descriptionAst
    variant
    hasAdditionalProperties
    required
    default
    resource {
      path
      title
    }
    resources {
      path
      title
    }
  }
`

export const query = graphql`
  query($id: String!) {
    endpoint(id: {
      eq: $id
    }) {
      id
      title
      verb
      url
      path
      descriptionAst
      requestContentType
      showExplorer
      defaultResponse {
        resources {
          jsonExample
        }
      }
      samples {
        id
        language
        code
      }
      responses {
        id
        code
        contentType
        descriptionAst
        anchor
        resources {
          path
          title
        }
      }
      server{
        url
      }
      relatedGuides {
        title
        path
        category {
          title
        }
      }
      params {
        ...endpointParamFields
        params {
          ...endpointParamFields
          params {
            ...endpointParamFields
            params {
              ...endpointParamFields
            }
          }
        }
      }
    }
  }
`